import { createSlice } from "@reduxjs/toolkit";

import { IIngredientStore } from "../types";

const initialState: IIngredientStore = {
  ingredients: [],
};

export const ingredientSlice = createSlice({
  name: "ingredient",
  initialState,
  reducers: {
    setIngredients: (state, { payload }) => {
      state.ingredients = payload;
    },
  },
});

export const { setIngredients } = ingredientSlice.actions;
